import { TypedDocumentNode } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { Query } from 'graphql/generated/graphqlTypes';
import { GET_DOORS_FOR_ACCESS_EVENTS_FILTERS, GET_VISITORS_ACCESS_EVENTS_FILTERS } from 'graphql/v2/queries';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { useEffect } from 'react';
import { BaseHookProps } from '../hooks.types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const GET_DOORS_FOR_ACCESS_EVENTS_FILTERS_TYPED: TypedDocumentNode<Pick<Query, 'getDoorsForTenant'>> =
  GET_DOORS_FOR_ACCESS_EVENTS_FILTERS;
const GET_VISITORS_ACCESS_EVENTS_FILTERS_TYPED: TypedDocumentNode<Pick<Query, 'getVisitors'>> =
  GET_VISITORS_ACCESS_EVENTS_FILTERS;

const useAccessEventsDataForFilters = ({ handleFetchError }: BaseHookProps) => {
  const { translation } = useTranslation();

  const { loading: doorsLoading, error: doorsError, data: doors } = useQuery(GET_DOORS_FOR_ACCESS_EVENTS_FILTERS_TYPED);

  useEffect(() => {
    if (doorsError) {
      handleFetchError(translation.devices_error_fetching);
      console.error(doorsError);
    }
  }, [doorsError]);

  const {
    loading: visitorsLoading,
    error: visitorsError,
    data: visitors
  } = useQuery(GET_VISITORS_ACCESS_EVENTS_FILTERS_TYPED);

  useEffect(() => {
    if (visitorsError) {
      handleFetchError(translation.users_error_fetching);
      console.error(visitorsError);
    }
  }, [visitorsError]);

  return {
    doors: doors?.getDoorsForTenant || [],
    doorsLoading,
    visitors: visitors?.getVisitors || [],
    visitorsLoading
  };
};

export default useAccessEventsDataForFilters;
